:host {
  --form-field-input-width: 240px;
  height: auto;
}

.form-section {
  margin-top: calc(var(--spacer) * 2.5);

  .flex-group {
    display: flex;
    align-items: flex-start;
  }
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
}
